// import CleverTap from 'clevertap-web-sdk';
function trackEvent(eventName, eventData) {
  trackWithCleverTap(eventName, eventData);
}

function trackMoengageEvents(eventName, eventData) {
  console.log('jitendra====>', eventData, eventName);
  if (typeof eventName !== 'string') return;
  if (!window?.Moengage) return;
  window.Moengage.track_event(eventName, eventData);
}

function trackWithCleverTap(eventName, eventData) {
  // CleverTap.event.push(eventName, eventData);
}

export { trackEvent, trackMoengageEvents };
